/* eslint-disable prefer-spread */
const baseUrl = process.env.REACT_APP_API_BASE_URL;
const MAX_URL_ELEMENTS_TO_REMOVE = 3;

export const getBaseUrl = (path) => {
  const removeUrlParts = baseUrl.split('/');
  const removePart =
    removeUrlParts.length >= MAX_URL_ELEMENTS_TO_REMOVE
      ? `/${removeUrlParts.slice(MAX_URL_ELEMENTS_TO_REMOVE).join('/')}`
      : null;
  const finalPath =
    removePart && path.indexOf(removePart) > -1
      ? path.replace(removePart, '')
      : path;

  return baseUrl + finalPath;
};

export const getBaseUrlRefresh = (path) => {
  return getBaseUrl(`${path}?refresh=${new Date().getTime()}`);
};

export const getApiUrl = (path) => {
  return getBaseUrl(`${path}`);
};

export const tokenInterceptor = (headers, { getState }) => {
  const state = getState();
  const token = state?.auth.token || '';
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
    headers.set('Accept', 'application/json');
  }
  return headers;
};

export const serializeQuery = (params, prefix) => {
  const query = Object.keys(params || {}).map((key) => {
    const value = params[key];
    let newKey = key;

    if (params.constructor === Array) newKey = `${prefix}[]`;
    else if (params.constructor === Object)
      newKey = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === 'object') return serializeQuery(value, newKey);
    return value !== undefined && value !== null
      ? `${newKey}=${encodeURIComponent(value)}`
      : undefined;
  });

  return query
    .filter((n) => n)
    .map(String)
    .join('&');
};

export const paramsSerializer = (params) => {
  const newParams = serializeQuery(params);
  return newParams;
};
